












































































































































import { EmployeApi } from "../api/EmployeApi";
import moment from "moment";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import { Employe } from "../models/Employe";
import AbsenceModal from "./AbsenceModal.vue";

export default {
    name: "CongesEmployesList",
    components: { AbsenceModal, ExportButton, Pagination },
    data() {
        return {
            selectedYear: moment().year(),
            search: "",
            employes: [],
            currentPage: 1,
            loading: false,
            EmployeApi: new EmployeApi(),
            showAbsenceModal: false,
        };
    },
    computed: {
        nextYear() {
            return Number(this.selectedYear) + 1;
        },
        totalPages() {
            return Math.ceil(this.employes.length / 10);
        },
    },
    created() {
        this.getEmployes();
    },
    methods: {
        getEmployes() {
            let self = this;
            self.loading = true;
            self.EmployeApi.getAll({
                include: "acquisition_conges",
                acquisition_conges_year: self.selectedYear,
            }).then(function (res) {
                self.loading = false;
                return (self.employes = res);
            });
        },
        changePage(page: number) {
            this.currentPage = page;
        },
        getExportParams() {
            return { acquisition_conges_year: this.selectedYear };
        },
        displayedEmployes(): Array<Employe> {
            let self = this;

            if (this.search) {
                return _.filter(this.employes, function (employe) {
                    return (
                        employe.nom
                            .toLowerCase()
                            .includes(self.search.toLowerCase()) ||
                        employe.prenom
                            .toLowerCase()
                            .includes(self.search.toLowerCase())
                    );
                });
            } else {
                return _.chain(this.employes)
                    .chunk(10)
                    .nth(this.currentPage - 1)
                    .value();
            }
        },
        // Absence
        createAbsence() {
            this.showAbsenceModal = true;
        },
        onAbsenceModalClose() {
            this.showAbsenceModal = false;
        },
        onAbsenceSaved() {
            this.getEmployes();
        },
    },
    watch: {
        selectedYear: {
            immediate: true,
            handler: function () {
                this.getEmployes();
            },
        },
    },
};
